import { Folder, Footage } from "../../models/Timeline";
import DirectoryEvents from "../events/DirectoryEvents";

// ディレクトリ一覧取得
export const GetDir = (parentId: number, userId: number) =>
    ({
        type: DirectoryEvents.GetDirStarted,
        parentId,
        userId,
    } as const);

export const GetDirComplete = (directoryList: Folder[], footageList: Footage[], parentId: number) =>
    ({
        type: DirectoryEvents.GetDirComplete,
        directoryList,
        footageList,
        parentId,
    } as const);

// ディレクトリ作成
export const CreateDir = (parentId: number, name: string, userId: number) =>
    ({
        type: DirectoryEvents.CreateDirStarted,
        parentId,
        name,
        userId,
    } as const);

export const CreateDirComplete = (newDirectory: Folder[], parentId: number) =>
    ({
        type: DirectoryEvents.CreateDirComplete,
        newDirectory,
        parentId,
    } as const);

// ディレクトリ名変更
export const RenameDir = (parentId: number, name: string, userId: number) =>
    ({
        type: DirectoryEvents.RenameDirStarted,
        parentId,
        name,
        userId,
    } as const);

export const RenameDirComplete = (renameDirectory: Folder[]) =>
    ({
        type: DirectoryEvents.RenameDirComplete,
        renameDirectory,
    } as const);

// ディレクトリ削除
export const DeleteDir = (id: number, isForce: boolean, userId: number) =>
    ({
        type: DirectoryEvents.DeleteDirStarted,
        id,
        isForce,
        userId,
    } as const);

export const DeleteDirComplete = (delDirectory: Folder, message: string) =>
    ({
        type: DirectoryEvents.DeleteDirComplete,
        delDirectory,
        message,
    } as const);

// フッテージアップロード
export const UploadFootage = (
    footageFile: File,
    name: string,
    directoryId: number,
    userId: number
) =>
    ({
        type: DirectoryEvents.UploadFootageStarted,
        footageFile,
        name,
        directoryId,
        userId,
    } as const);

// フッテージ名変更
export const RenameFootage = (id: number, name: string, userId: number) =>
    ({
        type: DirectoryEvents.RenameFootageStarted,
        id,
        name,
        userId,
    } as const);

export const RenameFootageComplete = (directoryList: Folder[], footageList: Footage[]) =>
    ({
        type: DirectoryEvents.RenameFootageComplete,
        directoryList,
        footageList,
    } as const);

export const UploadFootageComplete = (directoryList: Folder[], footageList: Footage[]) =>
    ({
        type: DirectoryEvents.UploadFootageComplete,
        directoryList,
        footageList,
    } as const);

// フッテージ削除
export const DeleteFootage = (footageId: number, userId: number, directoryId: number) =>
    ({
        type: DirectoryEvents.DeleteFootageStarted,
        footageId,
        userId,
        directoryId,
    } as const);

export const DeleteFootageComplete = (directoryList: Folder[], footageList: Footage[]) =>
    ({
        type: DirectoryEvents.DeleteFootageComplete,
        directoryList,
        footageList,
    } as const);

export const DeleteFootageFailed = (error: string) =>
    ({
        type: DirectoryEvents.DeleteFootageFailed,
        error,
    } as const);

export const ResetDeleteError = () =>
    ({
        type: DirectoryEvents.ResetDeleteError,
    } as const);
